import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { PlaylistLandscapeImg } from './playlist_landscape_img';
export const HeroHeader = (props) => {
    const { heroURL, videoVisible, children, isPlaylist } = props;
    const styles = StyleSheet.create({
        container: {
            position: 'relative',
            backgroundColor: Colors.StrictBlack,
        },
        backgroundImg: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
        },
        thumbnail: {
            height: '100%',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: `url(${heroURL})`,
        },
    });
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.backgroundImg) }, !videoVisible && isPlaylist ? (React.createElement(PlaylistLandscapeImg, { thumbnailURL: heroURL })) : (React.createElement("div", { className: css(styles.thumbnail) }))),
        children));
};
